import React from 'react';

const KPICard = ({ 
  title, 
  value, 
  change, 
  target, 
  progress, 
  marginValue,
  marginPercent,
  subtitle,
  icon, 
  color = 'blue',
  reportLink 
}) => {
  const getChangeColor = (change) => {
    if (change > 0) return 'text-green-600';
    if (change < 0) return 'text-red-600';
    return 'text-gray-600';
  };

  const getChangeIcon = (change) => {
    if (change > 0) return '↗';
    if (change < 0) return '↘';
    return '→';
  };

  const formatValue = (value, type) => {
    if (type === 'currency') {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    }
    if (type === 'percentage') {
      return `${value.toFixed(1)}%`;
    }
    // Format numbers without decimal places
    return Math.round(value).toLocaleString();
  };

  const getValueType = (title) => {
    if (title.includes('Sales') || title.includes('Revenue')) return 'currency';
    if (title.includes('Margin')) return 'percentage';
    return 'number';
  };

  const getCardAccent = (title) => {
    switch (title) {
      case 'Sales Today':
        return 'border-l-blue-500';
      case 'Revenue & Margin':
        return 'border-l-green-500';
      case 'Current Month Invoices Raised':
        return 'border-l-purple-500';
      case 'Current Month Credits Raised':
        return 'border-l-red-500';
      case 'Current Month Nett Sales':
        return 'border-l-blue-500';
      case 'Total Revenue & Margin':
        return 'border-l-green-500';
      case 'Visits Completed':
        return 'border-l-orange-500';
      default:
        return 'border-l-gray-500';
    }
  };

  const accentColor = getCardAccent(title);

  return (
    <div className={`bg-white rounded-xl shadow-lg border-l-4 ${accentColor} border border-gray-200 p-6 hover:shadow-xl transition-all duration-300`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-600 uppercase tracking-wide">{title}</h3>
        {icon && (
          <div className="p-2 rounded-lg bg-gray-100 text-gray-600">
            {icon}
          </div>
        )}
      </div>
      
      <div className="mb-4">
        <div className="text-4xl font-bold text-gray-900 mb-2">
          {formatValue(value, getValueType(title))}
        </div>
        {subtitle && (
          <div className="text-xs text-gray-500 mb-2">
            {subtitle}
          </div>
        )}
        {change !== undefined && change !== 0 && (
          <div className={`text-sm font-semibold ${getChangeColor(change)} flex items-center`}>
            <span className="mr-1">{getChangeIcon(change)}</span>
            {Math.abs(change).toLocaleString()}
          </div>
        )}
      </div>

      {(title === 'Revenue & Margin' || title === 'Total Revenue & Margin') && (
        <div className="text-sm text-gray-600">
          <div className="font-medium">
            Margin: {formatValue(marginValue || change || 0, 'currency')} ({
              (() => {
                const percent = marginPercent !== undefined ? marginPercent : progress;
                if (percent === null || percent === undefined || isNaN(percent)) return '0.0';
                return Math.max(0, Math.min(100, parseFloat(percent))).toFixed(1);
              })()
            }%)
          </div>
        </div>
      )}

      {reportLink && (
        <div className="pt-2 border-t border-gray-100">
          <a 
            href={reportLink} 
            className="text-sm text-indigo-600 hover:text-indigo-800 font-medium transition-colors"
          >
            View Report →
          </a>
        </div>
      )}
    </div>
  );
};

export default KPICard;